import { ApplicationsPageContent } from ".";

export default function AssociateApplicationsPage() {
  return <ApplicationsPageContent activeTab="associate" />;
}
